import { useAccessCta } from '@/features/home/hooks/useAccessCta'

/**
 * The one "build" call to action on /agents. Signed-in users land in the
 * builder; everyone else goes through sign-up first. Same label everywhere
 * so the page has exactly one CTA per intent.
 */
export function useBuildTeamCta() {
  const cta = useAccessCta()
  return {
    to: cta.signedIn ? '/dashboard/agents/new' : cta.to,
    label: 'Build an agent team',
  } as const
}
